import { render, staticRenderFns } from "./PaymentMethodsForm.vue?vue&type=template&id=3ac22ffa&scoped=true&"
import script from "./PaymentMethodsForm.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodsForm.vue?vue&type=style&index=0&id=3ac22ffa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac22ffa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VAlert,VCheckbox})
